const PhotoSwipe = require('photoswipe');
const PhotoSwipeUIDefault = require('photoswipe/dist/photoswipe-ui-default');

$(document).ready(() => {
    $('body').on('click', '.js-zoom-image, .js-product-image', (e) => {
        e.preventDefault();
        let gallery;
        const $imagesSection = $('.js-images-section');
        const photoSwipe = (() => {
            const pswpElement = $('.pswp');
            const values = $('.js-product-images img');
            const pswpItems = values
                .filter((index, elem) => !$(elem).parents('.slick-cloned').length)
                .map((index, element) => {
                    const imageAspectDimension = element.clientHeight * 2;
                    return {
                        src: element.src.replace(/\?.*$/, ''),
                        w: imageAspectDimension,
                        h: imageAspectDimension
                    };
                });
            const pswpOptions = {
                index: 0,
                maxSpreadZoom: 1.5,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                closeOnScroll: false,
                closeOnVerticalDrag: false
            };

            const hideHint = () => {
                setTimeout(() => {
                    $('.js-zoom-message').hide();
                }, 2000);
            };
            const toggleZoomClass = () => {
                $('html').toggleClass('h-zoom-activated');
            };
            const appendControls = () => {
                const initialIndex = gallery.getCurrentIndex();
                let $controlButtons = '';
                for (let index = 0; index < pswpItems.length; index++) {
                    $controlButtons += `<button class="${index === initialIndex ? 'active' : ''}"></button>`;
                }
                $('.js-photoswipe-controls')
                    .empty()
                    .html($controlButtons);
            };
            const updateControls = () => {
                const currentIndex = $imagesSection.data('slide-index');
                $('.js-photoswipe-controls button').removeClass('active');
                $($('.js-photoswipe-controls button')[currentIndex]).addClass('active');
            };
            const initEvents = () => {
                gallery.listen('close', () => {
                    toggleZoomClass();
                });
                gallery.listen('beforeChange', () => {
                    $imagesSection
                        .data('slide-index', gallery.getCurrentIndex())
                        .trigger('slideUpdated');
                });
                $($imagesSection).on('slideUpdated', () => {
                    updateControls();
                    if ($('html').hasClass('h-zoom-activated') && $imagesSection.data('slide-index') !== gallery.getCurrentIndex()) {
                        gallery.goTo($imagesSection.data('slide-index'));
                    }
                });
                $('.js-photoswipe-controls').on('touchend click', 'button', (e) => {
                    updateControls();
                    gallery.goTo($(e.target).index());
                });
            };

            return {
                openPhotoSwipe: () => {
                    pswpOptions.index = $imagesSection.data('slide-index');
                    gallery = new PhotoSwipe(
                        pswpElement[0],
                        PhotoSwipeUIDefault,
                        pswpItems,
                        pswpOptions
                    );

                    gallery.init();
                    toggleZoomClass();
                    hideHint();
                    initEvents();
                    appendControls();
                }
            };
        })();

        photoSwipe.openPhotoSwipe();
    });
});
